import React, { useEffect } from "react";

import { Provider } from "@shopify/app-bridge-react";

import EnvironmentSelection from "./EnvironmentSelection";

import { CmsConstructor } from "../helpers/cmsConstructor";
import { useCmsHook } from "../helpers/cmsHook";

const EnvSelection = () => {
  const { setCmsInstance } = useCmsHook();

  const config = {
    apiKey: process.env.REACT_APP_SHOPIFY_CLIENT,
    host: new URLSearchParams(window.location.search).get("host"),
  };

  useEffect(() => {
    if (window.location.pathname === "/settings") {
      const cmsInstance = async () => {
        const cmsObj = await CmsConstructor();
        setCmsInstance(cmsObj);
      };
      cmsInstance();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Provider config={config}>
      <EnvironmentSelection />
    </Provider>
  );
};

export default EnvSelection;
